<template>
  <div class="mx-0 my-auto text-center">
    <img
      v-bind="disalbeCopy"
      :src="webpImageUrl"
      class="w-full my-0 mx-auto max-w-2xl lg:max-w-4xl"
    />
  </div>
</template>

<script lang="ts">
import { IContext } from '@/store/modules/common/types';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { webpImage } from '@forchange/cleword-utils';

@Component
export default class ImageSlide extends Vue {
  @Prop({ type: Object, default: () => {} }) content!: IContext;

  get webpImageUrl() {
    return webpImage(this.content.value);
  }

  get disalbeCopy() {
    if (this.$store.state.common.disalbeCopy) {
      return {
        style:
          'user-select: none;-webkit-user-drag: none;-webkit-user-select: none;-webkit-touch-callout: none;',
        oncontextmenu: 'return false;'
      };
    }
    return {};
  }
}
</script>
